import { useNotifications } from "@/context/NotificationContext";

const icons: Record<string, string> = {
  success: "ri-checkbox-circle-line",
  error: "ri-error-warning-line",
  warning: "ri-alert-line",
  info: "ri-information-line",
};

const colors: Record<string, string> = {
  success: "border-cyber-green/40 text-cyber-green",
  error: "border-cyber-red/40 text-cyber-red",
  warning: "border-cyber-orange/40 text-cyber-orange",
  info: "border-electric-blue/40 text-electric-blue",
};

export default function ToastContainer() {
  const { toasts, dismissToast } = useNotifications();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-3 max-w-sm w-full">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 px-4 py-3 rounded-xl border backdrop-blur-sm animate-slide-up ${colors[toast.type]}`}
          style={{ background: "rgba(10,11,16,0.97)" }}
        >
          <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
            <i className={`${icons[toast.type]} text-base`} />
          </div>
          <span className="text-white text-sm flex-1">{toast.message}</span>
          <button
            onClick={() => dismissToast(toast.id)}
            className="w-5 h-5 flex items-center justify-center text-silver-dim hover:text-white cursor-pointer flex-shrink-0"
          >
            <i className="ri-close-line text-sm" />
          </button>
        </div>
      ))}
    </div>
  );
}
